import { matchPath } from 'react-router-dom';
import {
  CREATE_PROJECT_PATH,
  PROJECT_DETAIL_PATH,
  PROJECT_SPAN_PATH,
} from '@/app/constants';

export const getProjectIdFromPath = (pathname: string) =>
  (
    matchPath(PROJECT_DETAIL_PATH, pathname) ??
    matchPath(PROJECT_SPAN_PATH, pathname)
  )?.params.projectId;

export const getProjectRouteScope = (
  pathname: string
): { isDraft: boolean; planId: string | undefined } => {
  if (matchPath(CREATE_PROJECT_PATH, pathname)) {
    return { isDraft: true, planId: undefined };
  }
  return { isDraft: false, planId: getProjectIdFromPath(pathname) };
};
